import { useLocation, Link } from "react-router-dom";
import { useEffect } from 'react';

export default function NotFound() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 bg-background-50">
      <div className="w-20 h-20 mb-6 flex items-center justify-center rounded-full bg-primary-100">
        <i className="ri-question-mark text-3xl text-primary-600"></i>
      </div>
      <div className="relative z-10">
        <h1 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-2">页面未找到</h1>
        <p className="text-sm text-foreground-500 mb-1">您访问的页面不存在或已删除</p>
        <p className="text-xs text-foreground-400 font-mono mb-6">{location.pathname}</p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-home-line"></i>
          </div>
          返回首页
        </Link>
      </div>
    </div>
  );
}